import { customAxios, USERNAME, IDUSUARIO, FDV_URL } from '../constants';

export default function(fdvID, codigo) {
  const config = {
    params: {
      codAprobFichaVtaAut: 'A',
      coUsuarioAut: USERNAME,
    },
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  return customAxios.put(`${FDV_URL}/ficha-venta/fichas-venta/${fdvID}/autorizaciones/${codigo}`, [], config);
}



// WEBPACK FOOTER //
// ./src/utils/autorizarActividad.js